<template>
  <div class="help-center">
    <button
      type="button"
      class="help-center__fab"
      title="Открыть справку"
      aria-label="Открыть справку"
      @click="openHelpPage"
    >
      ?
    </button>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

const openHelpPage = () => {
  void router.push('/help')
}
</script>

<style scoped>
.help-center {
  position: relative;
}

.help-center__fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1000;
  width: 56px;
  height: 56px;
  border: none;
  border-radius: 50%;
  background: #0f172a;
  color: #fff;
  font-size: 1.75rem;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.22);
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    background-color 0.15s ease;
}

.help-center__fab:hover {
  background: #1e293b;
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.28);
}

.help-center__fab:focus-visible {
  outline: 2px solid #93c5fd;
  outline-offset: 3px;
}

@media (max-width: 600px) {
  .help-center__fab {
    right: 16px;
    bottom: 16px;
    width: 52px;
    height: 52px;
    font-size: 1.5rem;
  }
}
</style>
